export const KEY_EDIT_PIZZA = 'edit-pizza-cart';

export const MAKE_YOUR_PIZZA = 'arma tu pizza';

export const CART_VARIANT_SIZES = {
  SMALL: 'small',
  LARGE: 'large'
};
